import { PERMISSIONS } from "@miplatform/constants";
import { BillingCommitmentType } from "@miplatform/types";

export const ACCOUNTING_TABS_NAMES = {
  ALL: "All",
  PRE_BILL: "Pre-Bill",
  PENDING_INVOICES: "Pending Invoices",
  INVOICED: "Invoiced",
};
export const BILLING_STATUS = {
  NONE: "None",
  PENDING_PREBILL: "PendingPrebill",
  PENDING_INVOICE: "PendingInvoice",
  INVOICED: "Invoiced",
};

export const ACCOUNTING_MODULE = "Accounting";

export const ACCOUNTING_DATE_PICKER_CALENDER_COUNT = 2;

export const ACCOUNTING_DATE_PICKER_MAX_SELECTION_DAYS = 30;

export const ACCOUNTING_DEFAULT_FIELD_WIDTH = 100;

export const ACCOUNTING_SORT_OPTIONS = {
  RECEIVED_DATE: "receivedDate",
  APPROVED_START_DATE: "approvedStartDate asc",
  MODIFIED_ON: "modifiedOn desc",
  REQUESTER: "requesterId desc",
  ADDRESS: { home: { address: ["addressLine1"] } },
};

export const ACCOUNTING_DATE_RANGE_OPTIONS = {
  RECEIVED_DATE: "receivedDate",
  PREBILL_COMPLETE_DATE: "prebillCompletedDate",
  INVOICE_DATE: "invoiceDate",
  APPROVED_START_DATE: "approvedStartDate",
};

export const ACCOUNTING_TABS = [
  {
    label: ACCOUNTING_TABS_NAMES.ALL,
    value: ACCOUNTING_TABS_NAMES.ALL,
    status: [
      BILLING_STATUS.PENDING_PREBILL,
      BILLING_STATUS.PENDING_INVOICE,
      BILLING_STATUS.INVOICED,
    ],
  },
  {
    label: ACCOUNTING_TABS_NAMES.PRE_BILL,
    value: ACCOUNTING_TABS_NAMES.PRE_BILL,
    status: [BILLING_STATUS.PENDING_PREBILL],
    sort: ACCOUNTING_SORT_OPTIONS.APPROVED_START_DATE,
    dateRange: ACCOUNTING_DATE_RANGE_OPTIONS.APPROVED_START_DATE,
    isAccountingModule: true,

    requiredPermissions: [
      PERMISSIONS.ORDER.PREBILL,
      PERMISSIONS.INVOICE.CREATE,
    ],
    permissionOperator: "AND",
  },
  {
    label: ACCOUNTING_TABS_NAMES.PENDING_INVOICES,
    value: ACCOUNTING_TABS_NAMES.PENDING_INVOICES,
    status: [BILLING_STATUS.PENDING_INVOICE],
    dateRange: ACCOUNTING_DATE_RANGE_OPTIONS.APPROVED_START_DATE,
    sort: ACCOUNTING_SORT_OPTIONS.APPROVED_START_DATE,
    invoicePaymentAllowed: true, // should be allowed to pay by invoice

    requiredPermissions: [PERMISSIONS.INVOICE.CREATE],
  },
  {
    label: ACCOUNTING_TABS_NAMES.INVOICED,
    value: ACCOUNTING_TABS_NAMES.INVOICED,
    status: [BILLING_STATUS.INVOICED],
    sort: ACCOUNTING_SORT_OPTIONS.ADDRESS,
    dateRange: ACCOUNTING_DATE_RANGE_OPTIONS.INVOICE_DATE,
    invoiceDate: true,
    CODPaymentAllowed: true,
    invoicePaymentAllowed: true,
    requiredPermissions: [
      PERMISSIONS.INVOICE.EXPORT,
      PERMISSIONS.INVOICE.CREATE,
      PERMISSIONS.ORDER.PRE_BILL,
    ],
  },
];

export const INVOICE_ITEM_TYPE = {
  MATERIAL: "Material",
  LABOR: "Labor",
  DISCOUNT: "Discount",
  OTHER: "Other",
};

export const RECONCILIATION_STEPS = {
  RECONCILIATION: 0,
  REVIEW_SUBMIT: 1,
};

export const INVOICING_ROUTES = {
  INVOICE: "invoice",
  INVOICED: "invoiced",
  PRE_BILL: "pre-bill",
};

export const GRID_CONFIGS = {
  INVOICE_ITEM: {
    item: 6,
    quantity: 1.5,
    unitPrice: 2.25,
    total: 2.25,
  },

  PAYMENT_ITEM: {
    payment: 9.75,
    billingCommitmentAmount: 2.25,
  },

  VARIANCE_ITEM: {
    name: 5,
    openBalance: 2,
    pricePaid: 2,
    invoiceId: 3,
  },
};

export const BillingCommitmentLabelMap = {
  [BillingCommitmentType.PurchaseOrder]: "Purchase Order",
  [BillingCommitmentType.Check]: "Check",
  [BillingCommitmentType.CreditCard]: "Credit Card",
  [BillingCommitmentType.Cash]: "Cash",
  [BillingCommitmentType.Other]: "Other",
};
